import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    padding: '0 0 2.4rem 0.8rem'
}))

export const CardBody = styled('div', () => ({
    display: 'flex',
    justifyContent: 'space-between'
}))

export const PaymentIconWrapper = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
}))

export const RightIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    color: $theme.colors.primary,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
}))

export const BodyWrapper = styled('div', () => ({
    cursor: 'pointer',
    display: 'flex',
    gap: '1.6rem'
}))

export const FlexContainer = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    display: 'flex',
    flexDirection: 'column'
}))

export const PaymentDetailsText = styled('span', () => ({
    fontWeight: 700,
    lineHeight: '1.6rem'
}))

export const IconsContainer = styled('div', () => ({
    display: 'flex',
    gap: '2.4rem'
}))

export const ValidThruContainer = styled('span', ({ $theme }) => ({
    fontSize: $theme.typography.LabelSmall.fontSize
}))
